import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Home from './pages/Home';
import ResearchStatement from './pages/ResearchStatement';
import EnergySystems from './pages/EnergySystems';
import FutureAgenda from './pages/FutureAgenda';
import About from './pages/About';
import Teaching from './pages/Teaching';
import Blogs from './pages/Blogs';
import Talks from './pages/Talks';
import News from './pages/News';
import PublicationsList from "./pages/PublicationsList";
import CoV1 from './pages/blogs/cov_series/CoV1';
import CoV2 from './pages/blogs/cov_series/cov2';
import './App.css';

// Active navigation state link helper
const NavLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  return (
    <Link to={to} className={isActive ? 'nav-link active' : 'nav-link'}>
      {children}
    </Link>
  );
};

function App() {
  return (
    <Router>
      <Helmet>
        <title>Biswadeep Chakraborty | Intelligence Layer for Critical Infrastructure</title>
      </Helmet>
      <div className="app">
        {/* Floating Navigation Bar */}
        <nav className="nav">
          <div className="nav-content">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/research-statement">PhD Research</NavLink>
            <NavLink to="/energy-systems">Energy & Infrastructure</NavLink>
            <NavLink to="/publications">Publications</NavLink>
            <NavLink to="/future-agenda">Future Agenda</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/news">News</NavLink>
            <NavLink to="/talks">Talks</NavLink>
          </div>
        </nav>

        {/* Main Content Viewport */}
        <main className="main">
          <Routes>
            {/* Homepage */}
            <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>Home | Biswadeep Chakraborty</title>
                  </Helmet>
                  <Home />
                </>
              }
            />

            {/* Research Statement / Fundamental AI */}
            <Route
              path="/research-statement"
              element={
                <>
                  <Helmet>
                    <title>PhD Research | Biswadeep Chakraborty</title>
                  </Helmet>
                  <ResearchStatement />
                </>
              }
            />

            {/* Energy Systems & Mercuria */}
            <Route
              path="/energy-systems"
              element={
                <>
                  <Helmet>
                    <title>Energy & Infrastructure | Biswadeep Chakraborty</title>
                  </Helmet>
                  <EnergySystems />
                </>
              }
            />

            {/* Future Research Agenda */}
            <Route
              path="/future-agenda"
              element={
                <>
                  <Helmet>
                    <title>Future Agenda | Biswadeep Chakraborty</title>
                  </Helmet>
                  <FutureAgenda />
                </>
              }
            />

            {/* About & Narrative Bio */}
            <Route
              path="/about"
              element={
                <>
                  <Helmet>
                    <title>About | Biswadeep Chakraborty</title>
                  </Helmet>
                  <About />
                </>
              }
            />

            {/* Publications */}
            <Route
              path="/publications"
              element={
                <>
                  <Helmet>
                    <title>Publications | Biswadeep Chakraborty</title>
                  </Helmet>
                  <PublicationsList />
                </>
              }
            />

            {/* Talks */}
            <Route
              path="/talks"
              element={
                <>
                  <Helmet>
                    <title>Talks | Biswadeep Chakraborty</title>
                  </Helmet>
                  <Talks />
                </>
              }
            />

            {/* News */}
            <Route
              path="/news"
              element={
                <>
                  <Helmet>
                    <title>News | Biswadeep Chakraborty</title>
                  </Helmet>
                  <News />
                </>
              }
            />

            {/* Teaching */}
            <Route
              path="/teaching"
              element={
                <>
                  <Helmet>
                    <title>Teaching | Biswadeep Chakraborty</title>
                  </Helmet>
                  <Teaching />
                </>
              }
            />

            {/* Blog Main Page */}
            <Route
              path="/blogs"
              element={
                <>
                  <Helmet>
                    <title>Blogs | Biswadeep Chakraborty</title>
                  </Helmet>
                  <Blogs />
                </>
              }
            />

            {/* Blog Series */}
            <Route path="/blogs/cov_series/cov1" element={<CoV1 />} />
            <Route path="/blogs/cov_series/cov2" element={<CoV2 />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
